import { createUseQueryHook } from './createUseQueryHook';

export const useTaxiDetails = createUseQueryHook(
    'person_trip_taxi_detail',
);
